import React, { useState, useEffect } from 'react';
import s from './s.module.less';
import { CloseOutlined } from '@ant-design/icons';

interface DrawerProps {
    visible: boolean;
    onClose: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ visible, onClose }) => {
    const [activeTab, setActiveTab] = useState<string>('FAQs');
    const [isAnimating, setIsAnimating] = useState<boolean>(false);
    const [shouldRender, setShouldRender] = useState<boolean>(false);

    const tabs = [
        'FAQs',
        'Webinar session',
    ];

    useEffect(() => {
        if (visible) {
            setShouldRender(true);
            // 使用setTimeout确保DOM渲染完成并且CSS初始状态已应用
            const timer = setTimeout(() => {
                setIsAnimating(true);
            }, 10); // 10ms足够让DOM渲染和CSS应用
            return () => clearTimeout(timer);
        } else {
            setIsAnimating(false);
            // 等待动画完成后再移除DOM
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 300); // 300ms 匹配CSS动画时长
            return () => clearTimeout(timer);
        }
    }, [visible]);

    const handleClose = () => {
        setIsAnimating(false);
        setTimeout(() => {
            onClose();
        }, 300); // 300ms 匹配CSS动画时长
    };

    if (!shouldRender) return null;

    return (
        <div className={`${s.drawerOverlay} ${isAnimating ? s.overlayVisible : s.overlayHidden}`}>
            <div className={`${s.drawer} ${isAnimating ? s.drawerVisible : s.drawerHidden}`}>
                {/* Header */}
                <div className={s.header}>
                    <div className={s.title}>Help & Resources</div>
                    <CloseOutlined className={s.closeIcon} onClick={handleClose} />
                </div>

                {/* Body */}
                <div className={s.body}>
                    <div className={s.tabContainer}>
                        {/* Tab Header */}
                        <div className={s.tabHeader}>
                            <div className={s.tabWrapper}>
                                <div className={s.bottomBorder} />
                                <div className={s.tabs}>
                                    {tabs.map((tab) => (
                                        <div
                                            key={tab}
                                            className={`${s.tab} ${activeTab === tab ? s.activeTab : ''}`}
                                            onClick={() => setActiveTab(tab)}
                                        >
                                            <div className={s.tabContent}>
                                                <span className={s.tabText}>{tab}</span>
                                            </div>
                                            {activeTab === tab && <div className={s.tabBottomBorder} />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className={s.tabContentArea}>
                            {activeTab === 'FAQs' && (
                                <div className={s.faqContent}>
                                    {/* FAQ content placeholder */}
                                    <div>FAQ content will be displayed here</div>
                                </div>
                            )}
                            {activeTab === 'Webinar session' && (
                                <div className={s.webinarContent}>
                                    {/* Webinar content placeholder */}
                                    <div>Webinar session content will be displayed here</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drawer;
